import script from "./ActionLogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionLogsTable.vue?vue&type=script&setup=true&lang=js"

import "./ActionLogsTable.vue?vue&type=style&index=0&id=50171538&lang=css"

const __exports__ = script;

export default __exports__